export default "__VITE_ASSET__CN0v9Svk__"